/* ==========================================================================
   Rook UI Core — Accordion Controller
   Web Component: <rk-accordion-element>
   ========================================================================== */

import { RkComponent } from '@rook/component';

class RkAccordionElement extends RkComponent {
    static hydration = 'idle';

    setup() {
        this.details = this.querySelector('details');
        this.content = this.querySelector('.rk-accordion__content');
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;

        if (!this.details || !this.content) return;

        this.delegate({
            'click summary': this.onClick,
        });
    }

    onClick(event) {
        event.preventDefault();

        this.details.style.overflow = 'hidden';

        if (this.isClosing || !this.details.open) {
            this.open();
        } else if (this.isExpanding || this.details.open) {
            this.shrink();
        }
    }

    shrink() {
        this.isClosing = true;

        const startHeight = `${this.details.offsetHeight}px`;
        const summary = this.details.querySelector('summary');
        const endHeight = `${summary.offsetHeight}px`;

        if (this.animation) {
            this.animation.cancel();
        }

        this.animation = this.details.animate(
            { height: [startHeight, endHeight] },
            { duration: 200, easing: 'ease-out' }
        );

        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
        this.details.style.height = `${this.details.offsetHeight}px`;
        this.details.open = true;

        window.requestAnimationFrame(() => this.expand());
    }

    expand() {
        this.isExpanding = true;

        const startHeight = `${this.details.offsetHeight}px`;
        const summary = this.details.querySelector('summary');
        const endHeight = `${summary.offsetHeight + this.content.offsetHeight}px`;

        if (this.animation) {
            this.animation.cancel();
        }

        this.animation = this.details.animate(
            { height: [startHeight, endHeight] },
            { duration: 200, easing: 'ease-out' }
        );

        this.animation.onfinish = () => this.onAnimationFinish(true);
        this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
        this.details.open = open;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.details.style.height = '';
        this.details.style.overflow = '';
    }
}

if (!customElements.get('rk-accordion-element')) {
    customElements.define('rk-accordion-element', RkAccordionElement);
}
